import {
  FETCH_FEATURE_FLAGS,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE,
} from "features/yard360/store/featureFlags/types";

export const INITIAL_FEATURE_FLAGS = {};

export const featureFlagsReducer = (state = INITIAL_FEATURE_FLAGS, action) => {
  switch (action.type) {
    // Batch fetch — the per-flag `{ enabled, fetching }` shape is preserved so
    // every `featureFlags[X].enabled` reader stays unchanged.
    case FETCH_FEATURE_FLAGS: {
      const { features } = action.payload;
      const next = { ...state };
      for (const feature of features) {
        next[feature] = { ...next[feature], fetching: true };
      }
      return next;
    }

    case FETCH_FEATURE_FLAGS_SUCCESS: {
      const { features } = action.payload;
      const next = { ...state };
      for (const { feature, enabled } of features) {
        next[feature] = { enabled, fetching: false };
      }
      return next;
    }

    case FETCH_FEATURE_FLAGS_FAILURE: {
      const { features, errorMessage } = action.payload;
      const next = { ...state };
      for (const feature of features) {
        next[feature] = { ...next[feature], fetching: false, errorMessage };
      }
      return next;
    }

    default:
      return state;
  }
};
